/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const AUTHORIZATION_SERVICE_UNAVAILABLE_ERROR =
  "Authorization service temporarily unavailable";
